// Bank Location options for the People admin form. The dropdown is
// labeled by country/region but its stored value is the 3-letter HOME
// CURRENCY code (user.bankCurrency) — that's what the foreign-transaction
// fee logic keys off (see api/my-expenses-line-items and
// src/pages/employee/NewExpenseReportPage.jsx). Extendable — just add
// entries here.
export const BANK_LOCATIONS = [
  { code: 'SA', label: 'Saudi Arabia', currency: 'SAR' },
  { code: 'AE', label: 'United Arab Emirates', currency: 'AED' },
  { code: 'KW', label: 'Kuwait', currency: 'KWD' },
  { code: 'QA', label: 'Qatar', currency: 'QAR' },
  { code: 'BH', label: 'Bahrain', currency: 'BHD' },
  { code: 'OM', label: 'Oman', currency: 'OMR' },
  { code: 'US', label: 'United States', currency: 'USD' },
  { code: 'GB', label: 'United Kingdom', currency: 'GBP' },
  { code: 'EU', label: 'Eurozone', currency: 'EUR' },
  { code: 'EG', label: 'Egypt', currency: 'EGP' },
  { code: 'IN', label: 'India', currency: 'INR' },
  { code: 'MK', label: 'North Macedonia', currency: 'MKD' },
];

// Default/unset = SAR, so employees with no bank location configured keep
// today's behavior (every non-SAR line is "foreign").
export function homeCurrencyFor(user) {
  return (user?.bankCurrency || 'SAR').toUpperCase();
}
